import { GridCellParams, GridRowParams } from '@mui/x-data-grid'

import { FIELD_VALUE_FORMAT } from '@constants'
import { ObjectDataRecord } from '@types'

export const toggleCheckboxValue = (params: GridRowParams<ObjectDataRecord> | GridCellParams) => {
  const isNumber = (params as any).colDef?.valueFormat === FIELD_VALUE_FORMAT.NUMBER
  const isBoolean = (params as any).colDef?.valueFormat === FIELD_VALUE_FORMAT.BOOLEAN
  let newValue

  if (isNumber) {
    newValue = (params as any).value ? 0 : 1
  }

  if (isBoolean) {
    newValue = !(params as any).value
  }

  return newValue
}
